<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { useChecklistControllerStore } from "~/composables/useChecklistControllerStore";

const documentId = inject("documentId") as any;
const { revision } = useSubmittedDocumentStore(documentId);

if (!revision) {
  throw new Error("Revision is not defined");
}

const documentChecklistStore = useDocumentChecklistStore(documentId);

const {
  useAllChecklistCriteria,
  useChecklist,
  useTotalScore,
  useTotalEarnedScore,
  isInitialized,
} = storeToRefs(documentChecklistStore);

if (!useChecklist || !useAllChecklistCriteria) {
  throw new Error("Checklist is not defined");
}

const store = useChecklistControllerStore(documentId);
const { currentStep, numSteps, currentStepIndex } = storeToRefs(store);

const { nextStep, previousStep, getCriteriaFromId } = store;

const isChecklistInitialized = computed(() => {
  return (
    currentStep.value &&
    currentStepIndex.value > 0 &&
    currentStepIndex.value < numSteps.value + 1
  );
});
</script>

<template>
  <div class="p-2 h-full">
    <DocumentPanelChecklistWelcome
      v-if="isInitialized && currentStepIndex == 0"
    />

    <!-- <ChecklistSummary
      v-if="isInitialized && currentStepIndex >= numSteps - 1"
      class="h-full overflow-auto"
    /> -->
    <div class="flex flex-col h-full min-h-0" v-if="isChecklistInitialized">
      <DocumentPanelChecklistStep
        v-if="currentStep!.checklistCriteriaId"
        :key="getCriteriaFromId(currentStep!.checklistCriteriaId)!.id"
        :criteria-instance="currentStep!"
        :checklist-criteria="getCriteriaFromId(currentStep!.checklistCriteriaId)!"
      />
      <DocumentPanelChecklistProgress
        :num-steps="numSteps"
        :current-step="currentStepIndex"
        :total-earned-score="useTotalEarnedScore"
        :total-score="useTotalScore"
        @next="nextStep"
        @previous="previousStep"
      />
    </div>
  </div>
</template>

<style scoped></style>
